module.exports = __webpack_public_path__ + "static/media/AvertaStd-Bold.447315c0.ttf";